<template>
	<div v-if="ticketID != null">
		<iframe :src="serverUrl + '/storage/tickets/ticket_' + ticketID + '.pdf'" width="100%" scrolling="auto" style="position: absolute; height: 100%; border: none"></iframe>
	</div>
</template>

<script>
import { mapState } from "vuex";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Tickets from "../apis/tickets";
import pdf from 'vue-pdf'

export default {
  name: "Event",
  components: {
    Header,
    Footer,
		pdf
  },
  data() {
    return {
			ticketID: null
    };
  },
  computed: {
		...mapState(["serverUrl"]),
  },
  created: function () {
    this.getTicket();
  },

  methods: {		
		getTicket() {
			var that = this;

			var alias = this.$route.params.id;

			Tickets.show(alias)
				.then((response) => {
					that.ticketID = response.data
				})
				.catch(function (err) {
						
				});
		}
  },
};
</script>
